import React from 'react';
import { Flex } from 'antd';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExToggleButton } from 'jf/components/DevExToggleButton';
import { useLivePropState } from 'jf/utils/useLivePropState';

const NPS_SCORES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const DEFAULT_NPS_LABELS = ['Not at all likely', 'Extremely likely'];

interface NetPromoterScoreProps {
  value?: number;
  onChange?: (score: number) => void;
  disabled?: boolean;
  numeric?: boolean;
  choiceLabels?: string[];
  editing?: boolean;
}

/**
 * Component for Net Promoter Scores (NPS) in surveys.
 * Renders as a numeric 1-10 choice block with square buttons.
 */
export const NetPromoterScore: React.FC<NetPromoterScoreProps> = (props) => {
  const theme = useDevExTheme();

  const [selectedScore, setSelectedScore] = useLivePropState(props.value, props.onChange);

  // Use choice labels defined on the model if available
  const npsLabels =
    props.choiceLabels && props.choiceLabels.length === 2 ? props.choiceLabels : DEFAULT_NPS_LABELS;

  return (
    <Flex vertical align="stretch" gap={theme.variable.spacing.sm}>
      <Flex gap="1%" style={{ height: 'min(58px, 14vw)' }}>
        {NPS_SCORES.map((score, i) => {
          return (
            <DevExToggleButton
              key={score}
              toggled={score === selectedScore}
              onClick={() => setSelectedScore(score)}
              disabled={props.disabled}
              style={{
                opacity: props.disabled ? theme.variable.opacity.disabled : 1,
                margin: '0px',
                padding: 0,
              }}
            >
              {score}
            </DevExToggleButton>
          );
        })}
      </Flex>
      {props.numeric && (
        <Flex
          justify="space-between"
          style={{ fontSize: theme.variable.fontSize.sm, color: theme.color.text.secondary }}
        >
          <span style={{ width: '50%', textAlign: 'left' }}>{npsLabels[0]}</span>
          <span style={{ width: '50%', textAlign: 'right' }}>{npsLabels[1]}</span>
        </Flex>
      )}
    </Flex>
  );
};
